import React, { FC, useState } from "react"

interface CopyButtonProps {
  text: string
  label?: string
}

const CopyButton: FC<CopyButtonProps> = ({ text, label = "コピー" }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!text || text === '-') {
      return
    }

    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (err) {
      // フォールバック: 古いブラウザ対応
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    }
  }

  return (
    <button
      onClick={handleCopy}
      className="bg-primary text-white border-none rounded-lg px-3 py-1.5 text-sm font-medium cursor-pointer transition-all flex-shrink-0 hover:bg-primary-dark hover:-translate-y-0.5 active:translate-y-0"
      style={{
        fontSize: copied ? '0.75rem' : '0.875rem',
        padding: copied ? '0.25rem 0.5rem' : '0.375rem 0.75rem'
      }}
    >
      {copied ? 'コピーしました！' : label}
    </button>
  )
}

export default CopyButton

